export const translations = {
  "You have a new appointment pending confirmation.": {
    english: "You have a new appointment pending confirmation.",
    spanish: "Tiene una nueva cita pendiente de confirmación.",
  },
  "Do you want to accept the appointment?": {
    english: "Do you want to accept the appointment?",
    spanish: "¿Desea aceptar la cita?",
  },
  "No": {
    english: "No",
    spanish: "No",
  },
  "Yes": {
    english: "Yes",
    spanish: "Sí",
  },
  "You {action} a chat with {provider} on {date} from {startTime} to {endTime} {timezone}": {
    english: "You {action} a chat with {provider} on {date} from {startTime} to {endTime} {timezone}",
    spanish: "Usted {action} un chat con {provider} el {date} de {startTime} a {endTime} {timezone}",
  },
  "accepted": {
    english: "accepted",
    spanish: "aceptó",
  },
  "rejected": {
    english: "rejected",
    spanish: "rechazó",
  },
  "Click Here To View Upcoming Chats": {
    english: "Click Here To View Upcoming Chats",
    spanish: "Haga clic aquí para ver los próximos chats",
  },
  "Chat with": {
    english: "Chat with",
    spanish: "Chat con",
  },
  "in": {
    english: "in",
    spanish: "en",
  },
  "your provider": {
    english: "your provider",
    spanish: "su proveedor",
  },
  "Unable to load details": {
    english: "Unable to load appointment details. Please try again.",
    spanish: "No se pudieron cargar los detalles de la cita. Por favor, inténtelo de nuevo.",
  },
  "Error occurred": {
    english: "An error occurred. Please try again.",
    spanish: "Ocurrió un error. Por favor, inténtelo de nuevo.",
  },
  "Could not process response": {
    english: "Could not accept or decline the appointment. Please try again.",
    spanish: "No se pudo aceptar o rechazar la cita. Por favor, inténtelo de nuevo.",
  },
};
